import { CurrencyConverterContext, type ICurrencyConverterContext } from 'BreetComponents';
import { useContext } from 'react';

export const useCurrencyConverterContext = (): ICurrencyConverterContext => {
	const currencyConverterContext = useContext(CurrencyConverterContext);

	if (!currencyConverterContext) {
		throw new Error('useCurrencyConverterContext must be used within a CurrencyConverterProvider');
	}

	return currencyConverterContext;
};
